export default {
  'guesssYouLike':	'猜你喜欢',
  'actorExhibitListText': ['代表产品', '新产品', '精品'],
  'actorExhibitTip': ['您暂时无法查看新产品，请前往', '您暂时无法查看精品，请前往'],
  'lookMore': '查看更多产品',
  'registerText': '注册',
  'actorIndex': '数据看板', 
  'personReport': '参展报告',
  'actorBase': '展商基础数据',
  'prodcutStatistics': '展品统计',
  'opporStatistics': '商脉圈统计',
  'inviteStatistics': '邀约统计',
  'IMStatistics': 'IM统计',
  'collectedStatistics': '收藏统计',
  'visitStatistics': '浏览统计',
  'subTitle':  '点击下方统计模块，可查看对应的客商明细',
  'subTitle2': '点击下方统计模块，可查看对应的指标明细',
  'subTitle3': '点击下方统计模块，可查看对应的商脉圈明细',
  'subTitle4': '点击下方统计模块，可查看对应的邀约明细',
  'subTitle5': '点击下方统计模块，可查看对应的IM明细',
  'look': '浏览量',
  'lookSub': '展商被浏览的总次数',
  'lookSub2': '展品被浏览的总次数',
  'visit': '访客数',
  'visitSub': '展商被浏览用户数量',
  'collected': '收藏人数（次数）',
  'collectedSub': '展商被收藏的人数（次数）',
  'collectedSub2': '展品被收藏的总人数',
  'lookNum': '浏览人数',
  'lookNumSub': '展品被浏览的总人数',
  'oppNum': '商脉圈总量',
  'oppNumSub': '展商发送商脉圈的总数量',
  'commentSum': '评论总量',
  'commentSub': '商脉圈被评论的总数量',
  'thumbsUp': '点赞总量（人数）',
  'thumbsUpSub': '商脉圈被点赞的总数量（总人数）',
  'inviteNum': '收到邀约总量',
  'inviteNumSub': '展商收到客商主动邀约的条数',
  'IMNum': 'IM互动人数',
  'IMNumSub': '和展商聊天的客商总人数',
  'unit': '人',
  'unit2': '次',
  'unit3': '条',
  'unit4': '人（次）',
  'unit5': '个',
  'unit6': '次（人）',
  'startDate': '开始时间',
  'endDate': '结束时间',
  'collectedActorNum': '收藏展商数量',
  'collectedActorNumSub': '客商收藏展商的数量',
  'collectedExhibitsNum': '收藏展品数量',
  'collectedExhibitsNumSub': '客商收藏展品的数量',
  'visitActorNum': '浏览展商数量',
  'visitActorNumSub': '客商浏览展商的数量',
  'visitExhibitNum': '浏览展品数量',
  'visitExhibitNumSub': '客商浏览展品的数量',
  'oppNumVisitorSub': '客商发送商脉圈的总次数',
  'sendInviteNum': '发出邀约总量',
  'sendInviteNumSub': '客商主动邀约展商的数据量',
  'IMNumVisitSub': '和客商聊天互动的展商总数量',
  'visitorList': '客商明细',
  'packUp': '收起',
  'uploadTips3': `超出上传限制，您最多可以上传的文件数为 `,
  'linkVisitor': '联系TA',
  'linkActor': '联系展商',
  'productListText': '展品明细',
  'oppListText': '商脉圈明细',
  'inviteListText': '邀约明细',
  'IMListText': 'IM明细',
  'actorListText': '展商明细',
  'personListText': "员工明细",
  'actorInviteNumSub': '展商邀约客商的条数',
  'reportPlaceholder': '按照展品名称搜索',
  'reportPlaceholder3': '按照商脉圈关键字搜索',
  // 'reportPlaceholder4': '按照员工姓名、手机号、邮箱搜索',
  'reportPlaceholder4': '按照员工姓名搜索',
  'reportPlaceholder5': '按照展商名称搜索',
  'reportPlaceholder6': '按照展商名称和展品名称称搜索',
  'dataListSubTitle' : '点击客商明细，可查看对应展品浏览的客商明细',
  'dataListSubTitle2': '点击客商明细，可查看对应商脉圈的客商明细',
  'dataListSubTitle3': '点击客商明细，可查看对应邀约的客商明细',
  'dataListSubTitle4': '点击客商明细，可查看对应IM的客商明细',
  'dataListSubTitle5': '点击客商明细，可查看对应展品收藏的客商明细',
  'dataListSubTitle6': '点击展商明细，可查看对应商脉圈的展商明细',
  'dataListSubTitle7': '点击展商明细，可查看对应邀约的展商明细',
  'dataListSubTitle8': '点击员工明细，可查看对应商脉圈的展商员工明细',
  'dataListSubTitle9': '如果您想看评论，请到商脉圈管理查看',

  'visitorName': "客商名称",
  'companyName': "公司",
  'post': '职务',
  'country': '国家',
  'province': '省份',
  'city': '城市',
  'numOfVisits': '浏览次数',
  'todoAction': '操作',
  'productName': '展品名称',
  'numOfVisits2': '被浏览次数',
  'numOfCollected': '被收藏次数',
  'oppContent': '商脉圈内容',
  'oppImgVideo': '商脉圈图片/视频',
  'numOfcommented': '被评论条数',
  'numOfLived': '被点赞次数',
  'collectedNum': '评论条数',
  'actorPerson': '展商员工',
  'mobile': '手机号',
  'email': '邮箱',
  'receivedInviteNum': '收到邀约总数',
  'hStatus': '状态',
  'interactNum': '互动人数',
  'interactPersonNum': '互动员工数',
  'hActorName': '展商名称',
  'zoomNum': '展位号',
  'hProductName': '展品名称',
  'hProductImgVideo': '展品图片/视频',
  'hProductImgVideo2': '展品图片',
  'hforActor': '所属展商',
  'invitePerson': '邀约员工',
  'lookDetail': "查看详情",

  'questionTip': '线上展平台将根据贵司填写的产品类别、材质、年出口额、起订量等内容，精准匹配合适的目标买家，将请务必认真、准确选填。',
  'questionTipVisitor': '线上展平台将根据您填写的问卷内容，精准匹配合适的目标卖家，将请务必认真、准确选填。',
  'questionTip2': '您选择的产品分类最多只能选择80项，请认真选择',
  'questionTip3': ['最多只能选择', '项，请认真选择', '此题', '项']
}
